import { HttpErrorResponse } from '@angular/common/http';

/** HTTP statuses that indicate unreachable backend — eligible for IndexedDB cache fallback. */
export function shouldAttemptOfflineFallback(error: { status?: number } | null | undefined): boolean {
  const status = error?.status;
  if (status === undefined || status === null) {
    return true;
  }
  if (status === 401 || status === 403 || status === 404) {
    return false;
  }
  return status === 0 || status === 502 || status === 503 || status === 504;
}

export function shouldAttemptNetworkCacheFallback(error: unknown): boolean {
  if (error instanceof HttpErrorResponse) {
    return shouldAttemptOfflineFallback(error);
  }
  return true;
}
